'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _mk_MK = require('../../vc-calendar/src/locale/mk_MK');

var _mk_MK2 = _interopRequireDefault(_mk_MK);

var _mk_MK3 = require('../../time-picker/locale/mk_MK');

var _mk_MK4 = _interopRequireDefault(_mk_MK3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Merge into a locale object
var locale = {
  lang: (0, _extends3['default'])({
    placeholder: 'Избери датум',
    rangePlaceholder: ['Од датум', 'До датум']
  }, _mk_MK2['default']),
  timePickerLocale: (0, _extends3['default'])({}, _mk_MK4['default'])
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

exports['default'] = locale;